import { ContextualMenuItemCombinedProps } from './types';

const usePresenter = (props: ContextualMenuItemCombinedProps): ContextualMenuItemCombinedProps => {
  return props;
};

export default usePresenter;
